import './ModifierWidgetV2.css'
import { InfoTooltip } from '../InfoTooltip/InfoTooltip'
import { SliderV2 } from '../SliderV2/SliderV2'

function ModifierWidgetV2Header({
  title,
  displayValue,
  tooltip
}: {
  title: string
  displayValue: string
  tooltip?: string
}) {
  return (
    <div className="modifier-widget-v2-header">
      <div className="modifier-widget-v2-title-section">
        <h4 className="modifier-widget-v2-title">{title}</h4>{' '}
        {tooltip && <InfoTooltip content={tooltip} size="small" />}
      </div>
      <div className="modifier-widget-v2-value-section">
        <h3 className="font-semibold">{displayValue}</h3>
      </div>
    </div>
  )
}

export function ModifierWidgetV2({
  title,
  tooltip,
  value,
  name,
  sliderControls = {
    min: 0,
    max: 100,
    step: 1
  },
  formatValue = (value: number) => String(value),
  onChange,
  onMouseUp
}: {
  title: string
  tooltip?: string
  sliderControls?: {
    min: number
    max: number
    step: number
  }
  showValue?: boolean
  value: number
  formatValue?: (value: number) => string
  name?: string
  onChange: (evt: React.ChangeEvent<HTMLInputElement>) => void
  onMouseUp?: (evt: React.SyntheticEvent<HTMLInputElement>) => void
}) {
  const { min, max, step } = sliderControls
  const displayValue = formatValue(value)

  return (
    <div className="modifier-widget-v2">
      <ModifierWidgetV2Header title={title} displayValue={displayValue} tooltip={tooltip} />
      <SliderV2
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={onChange}
        onMouseUp={onMouseUp}
        name={name}
      />
    </div>
  )
}
